<template>
  <div class="table-action-wrapper scan-and-print-tracking" ref="container">
    <div style="width: 350px">
      <div class="d-flex align-items-center">
        <span class="pr-2">Action:</span>
        <Select :options="Object.values(scanAndActionOptions)" data-title="Action" class="has-tip d-inline-block" v-model="action" style="width: 250px"></Select>
      </div>
      <div class="item-selected mb-0 mt-2">ID: {{ id || 'Listening' }}</div>
    </div>
  </div>
</template>
<script>
import pdfjsLibUrl from '@/vendor/pdfjs/pdf.js?url'
import pdfWorkerUrl from '@/vendor/pdfjs/pdf.worker.js?url'
export default {
  data() {
    return {
      id: '',
      action: 'print_label',
      debounce: {
        submit: _.debounce(this.submit, 300)
      }
    }
  },
  async mounted() {
    document.addEventListener('keydown', this.scanning)
    if (!window?.pdfjsLib) {
      await this.$util.injectScript({ src: pdfjsLibUrl, type: 'module' })
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl
    }
  },
  unmounted() {
    document.removeEventListener('keydown', this.scanning)
  },
  computed: {
    extraAttributes() {
      return this.config?.extraAttributes || {}
    },
    scanAndActionOptions() {
      return this.extraAttributes?.scan_and_action || {}
    }
  },
  methods: {
    isPDF(arrayBuffer) {
      const bytes = new Uint8Array(arrayBuffer)
      return bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46 && bytes[4] === 0x2d
    },
    scanning(e) {
      if (!document.hasFocus() || ['INPUT', 'TEXTAREA', 'SELECT', 'BUTTON'].includes(document.activeElement.tagName) || document.activeElement.isContentEditable) {
        return false
      }
      if (/^[0-9a-zA-Z=]$/.test(e.key)) {
        this.id += String(e.key)
        this.debounce.submit(this.id)
      }
    },
    async submit() {
      try {
        switch (this.action) {
          case 'print_label':
            await this.submitPrintTracking()
            break
          case 'make_verified':
            await this.submitMakeVerified()
            break
          case 'find':
            this.$emit('change-filters', { search: this.id, search_by: null }, { refresh: true, goToFirst: true })
            break
          case 'in_queue':
            await this.submitInQueue()
            break
          default:
            this.$util.notify({
              text: `This action is not supported!`,
              status: 'error'
            })
            break
        }
      } catch (error) {
        console.error(error)
      }

      this.id = ''
    },
    async submitPrintTracking() {
      const response = await this.$util.get(`order/get-by-line-item/${this.id}`, {}, this.$refs.container)
      if (response.status != 'success') return
      let shipments = Object.values(response.data.purchase_detail.shipments)
      let shipment = Object.values(shipments)[0] || {}
      if (!_.isString(shipment.attachment)) {
        return this.$util.notify({
          text: 'Order don’t have attachment',
          status: 'error'
        })
      }

      const res = await this.$util.storage.getProxy(shipment.attachment, null, {
        responseType: 'arraybuffer'
      })
      const style = `#container{display:flex;height:100vh;justify-content:center;align-items:center}img{width:100%}`
      if (this.isPDF(res)) {
        const pdf = await window.pdfjsLib.getDocument(res).promise
        const page = await pdf.getPage(1)
        const viewport = page.getViewport({ scale: 2 })

        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        canvas.width = viewport.width
        canvas.height = viewport.height
        await page.render({ canvasContext: context, viewport }).promise
        canvas.toBlob(
          (blob) => {
            const url = URL.createObjectURL(blob)
            let html = `<img src="${url}">`
            this.$util.print({ html, size: '10cm 15cm', style })
          },
          'image/jpeg',
          1.0
        )
      } else {
        const blob = new Blob([res])
        const url = URL.createObjectURL(blob)
        let html = `<img src="${url}">`
        this.$util.print({ html, size: '10cm 15cm', style })
      }
    },
    async submitMakeVerified() {
      await this.$util.post(`order/verify/${this.id}`, {}, this.$refs.container)
      this.$emit('change-filters', { search: this.id, search_by: null }, { refresh: true, goToFirst: true })
    },
    async submitInQueue() {
      await this.$util.post(`order/in-queue/${this.id}`, {}, this.$refs.container)
      this.$emit('change-filters', { search: this.id, search_by: null }, { refresh: true, goToFirst: true })
    }
  },
  props: {
    config: Object
  }
}
</script>
